/**
 * Converts a whole number percentage to its decimal representation.
 * @param percentage - The whole number percentage to convert.
 * @returns The decimal representation of the percentage.
 */
export function getDecimalFromWholeNumber(percentage: number): number {
  return percentage / 100
}

/**
 * Subtracts multiple numbers sequentially.
 * @param numbers - The numbers to subtract.
 * @returns The result of subtracting the numbers in order.
 * @example
 * // Returns 5
 * subtractMultiple(20, 5, 5, 5);
 */
export function subtractMultiple(...numbers: number[]): number {
  if (numbers.length === 0) {
    throw new Error('At least one number must be provided')
  }
  return numbers.reduce((acc, curr) => acc - curr)
}
